import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=c35f4e7c&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=c35f4e7c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35f4e7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c35f4e7c')) {
      api.createRecord('c35f4e7c', component.options)
    } else {
      api.reload('c35f4e7c', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=c35f4e7c&scoped=true&", function () {
      api.rerender('c35f4e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Xda6ljlxhAjN/JS/comp/Paginate.vue"
export default component.exports